/**
 * Randuri-schelet cu EXACT inaltimea randului final (`--row-h`), deci zero deplasare de layout
 * la sosirea datelor. Un skelet mai scurt decat randul real e mai rau decat niciun skelet:
 * grila sare sub cursor exact cnd omul e pe punctul sa apese.
 */

export interface PropsSkeletonRows {
  /** Cate randuri. Implicit 12 — mediana unei zile e ~20 de plati, 12 umple un ecran. */
  numar?: number;
  /**
   * Latimile coloanelor, in aceeasi ordine ca grila reala. Valorile sunt clase Tailwind ca sa
   * poata fi sincronizate cu grila fara CSS-in-JS.
   */
  coloane?: readonly string[];
  className?: string;
}

const COLOANE_IMPLICITE = ['w-8', 'w-56', 'w-24', 'w-20', 'w-28', 'w-16'] as const;

export function SkeletonRows({
  numar = 12,
  coloane = COLOANE_IMPLICITE,
  className,
}: PropsSkeletonRows) {
  return (
    <div className={className} aria-hidden="true">
      {Array.from({ length: numar }, (_, i) => (
        <div key={i} className="rand-plata flex items-center gap-2 px-2">
          {coloane.map((w, j) => (
            <span key={j} className={`schelet h-3 ${w}`} style={{ animationDelay: `${i * 40}ms` }} />
          ))}
        </div>
      ))}
    </div>
  );
}

/** Anuntul pentru cititoarele de ecran, separat de forma vizuala. */
export function SkeletonAnunt({ text = 'Se încarcă plățile zilei' }: { text?: string }) {
  return (
    <p className="doar-sr" role="status">
      {text}
    </p>
  );
}
